"use client";
import classNames from "classnames";
import styles from "./styles.module.scss";
import Image from "next/image";
import IconArrowChevronLeft from "@/components/Icon/IconArrowChevronLeft.svg";
import IconArrowChevronRight from "@/components/Icon/IconArrowChevronRight.svg";
import IconStarGray from "@/components/Icon/IconStarGray.svg";
import IconStarGold from "@/components/Icon/IconStarGold.svg";

import { useRef } from "react";
import { format } from "date-fns";

export default function Component({ review, className, ...restProps }) {
  const imagesRef = useRef(null);
  const imageRef = useRef(null);
  const scrollRight = () => {
    const left = imageRef.current.clientWidth + 8;
    imagesRef.current.scrollBy({ left: left, behavior: "smooth" });
  };
  const scrollLeft = () => {
    const left = imageRef.current.clientWidth + 8;
    imagesRef.current.scrollBy({ left: -left, behavior: "smooth" });
  };
  return (
    <div className={classNames("flex flex-col gap-2 py-8", className)} {...restProps}>
      <div className="flex gap-2">
        <p className="font-bold text-base">{review.author}</p>
        <p className="text-sm text-grey">on {format(review.dateCreated, "MMMM d, yyyy")}</p>
      </div>
      <div className={"flex gap-1 py-2"}>
        {[...Array(5)].map((_, index) =>
          index < review.reviewRating ? (
            <Image key={`star-${index}`} src={IconStarGold.src} alt="" width={14} height={14} />
          ) : (
            <Image key={`star-${index}`} src={IconStarGray.src} alt="" width={14} height={14} />
          )
        )}
      </div>
      <p className="text-base">{review.reviewMessage}</p>
      <div className="flex flex-wrap">
        {/* {review.reviewOptionsList.map((detail, index) => (
          <div key={`product-review-detail-${index}`} className="w-1/2 md:w-1/4 flex flex-col gap-1 my-2 md:my-0">
            <p className="text-sm font-bold">{detail.message}</p>
            <div className={"flex gap-1 py-2"}>
              {[...Array(5)].map((_, index) =>
                index < detail.value ? (
                  <Image key={`star-${index}`} src={IconStarGold.src} alt="" width={14} height={14} />
                ) : (
                  <Image key={`star-${index}`} src={IconStarGray.src} alt="" width={14} height={14} />
                )
              )}
            </div>
          </div>
        ))} */}
      </div>
      {/* <div ref={imagesRef} className={classNames(styles.imageContainer)}>
        {review.images.map((image, index) => (
          <div
            key={`product-review-image-${index}`}
            className="w-[119px] md:w-[175px] h-[119px] md:h-[175px] cursor-pointer"
          >
            <Image
              src={image}
              width="175"
              height="175"
              alt={`review-${index}`}
              className="w-[119px] md:w-[175px] h-[119px] md:h-[175px]"
            />
          </div>
        ))}
      </div>
      {review.images.length > 2 && (
        <div className="flex md:hidden gap-2 ml-auto">
          <div
            className="w-8 h-8 border-[1px] border-black flex rounded-full cursor-pointer"
            onClick={() => scrollLeft()}
          >
            <Image
              src={IconArrowChevronLeft.src}
              width="6"
              height="18"
              alt="IconArrowChevronLeft"
              className="h-3 w-[6px] m-auto"
            />
          </div>
          <div
            className="w-8 h-8 border-[1px] border-black flex rounded-full cursor-pointer"
            onClick={() => scrollRight()}
          >
            <Image
              src={IconArrowChevronRight.src}
              width="6"
              height="18"
              alt="IconArrowChevronLeft"
              className="h-3 w-[6px] m-auto"
            />
          </div>
        </div>
      )} */}
    </div>
  );
}
